import { Pipe, PipeTransform } from '@angular/core';
import {User} from '../api/user/user.model';

@Pipe({
  name: 'userFullName'
})
export class UserFullNamePipe implements PipeTransform {

  transform(user: User): any {

    if (user !== undefined && user.id !== '') {
      return User.getFullName(user);
    }
    return '';
  }

}
